export const PRIORITY_ERROR = 'กรุณากลับไปจัดอันดับสาขาวิชาและบันทึกอีกครั้งก่อนยืนยันการสมัคร';
// สาขาในอันดับหายจาก courses_round3.json (ถอนหลักสูตรกลางฤดู) — ต้องให้เด็กถอดออกเองก่อนบันทึก
export const MISSING_COURSE_ERROR = 'มีสาขาวิชาในอันดับที่ไม่พบในระบบแล้ว กรุณาถอดออกจากอันดับก่อนบันทึกรายการ';
export const MISSING_COURSE_LABEL = 'ไม่พบสาขาวิชานี้ในระบบแล้ว (อาจถูกถอนการรับสมัคร) กรุณาถอดออก';

// Only drafts may be renumbered. Confirmed ranks must be validated as saved.
export const normalizeDraftPriorities = (projects) => projects.map((project, index) => ({
  ...project,
  priority: index + 1
}));

export const hasValidPriorities = (projects, { allowEmpty = false, idField = 'program_project' } = {}) => {
  if (!Array.isArray(projects) || projects.length > 10 || (!allowEmpty && !projects.length)) return false;
  const ids = new Set();
  return projects.every((project, index) => {
    const id = project && project[idField];
    if (typeof id !== 'string' || !/^[a-f\d]{24}$/i.test(id) || ids.has(id.toLowerCase())) return false;
    ids.add(id.toLowerCase());
    return project.priority === index + 1;
  });
};
